

import {  Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./page/Homepage";
import AboutUs from "./page/AboutUs";
import Services from "./page/Services";
import ContactUs from "./page/ContactUs";


// import ScrollToTop from "./components/utility/ScrollToTop"; 

function App() {
  return (
    <>
      <Navbar />
      <Routes>
          {/* <ScrollToTop /> */}
        <Route path="/" element={ <Home /> } />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
<Footer/>
    </>
  );
}

export default App;
